import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { VoyageActionsParams } from "@/api/types"

export function voyageActionsOptions(params: VoyageActionsParams = {}) {
	return queryOptions({
		queryKey: ["products", "euets", "voyage-actions", params],
		queryFn: () =>
			GET("/api/v1/euets/voyage-actions", {
				params: { query: params },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useVoyageActions(params: VoyageActionsParams = {}) {
	return useQuery(voyageActionsOptions(params))
}

export function voyageActionStatsOptions() {
	return queryOptions({
		queryKey: ["products", "euets", "voyage-actions", "stats"],
		queryFn: () => GET("/api/v1/euets/voyage-actions/stats"),
	})
}

export function useVoyageActionStats() {
	return useQuery(voyageActionStatsOptions())
}
